import Vue from 'vue'
import Vuex from 'vuex'

import users from './modules/users'
import themes from './modules/themes'
import orders from './modules/orders'
import shared from './modules/shared'
import { firebaseMutations } from 'vuexfire'

Vue.use(Vuex)

export const store = new Vuex.Store({
  mutations: { ...firebaseMutations },
  modules: {
    users,
    themes,
    orders,
    shared
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js